import {
  USERMANAGEMENT_LIST_SUCCESS,
  USERMANAGEMENT_LIST_FAILURE,
  REMAINING_LICENSES_SUCCESS,
  REMAINING_LICENSES_FAILURE,
  ADD_USER_SUCCESS,
  ADD_USER_FAILURE,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  GET_ROLE_LIST_SUCCESS,
  GET_ROLE_LIST_FAILURE,
  GET_COMPANY_LIST_SUCCESS,
  GET_COMPANY_LIST_FAILURE,
  GET_TOOLTIP_SUCCESS,
  GET_TOOLTIP_FAILURE,
  ACTIVE_DEACTIVE_SUCCESS,
  ACTIVE_DEACTIVE_FAILURE,
  RESET_TOAST_MESSAGE,
  SEARCH_USER,
  SEARCH_USER_FAILURE,
} from '../actions/UserManagementActions'

const initialState = {
  loading: true,
  userManagementList: [],
  editFormInitialValues: {},
  remainingLicensesLoading: true,
  remainingLicenses: {},
  addUserLoading: true,
  addUserRes: {},
  updateUserLoading: true,
  updateUserRes: {},
  deleteUserLoading: true,
  deleteUserRes: {},
  roleListLoading: true,
  roleList: [],
  getCompanyLoading: true,
  getCompanyList: [],
  tooltiplistLoading: true,
  tooltiplist: {},
  activeDeactiveLoading: true,
  activeDeactiveRes: {},
}

const userManagementReducer = function (state = initialState, action) {
  switch (action.type) {
    case USERMANAGEMENT_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        userManagementList: action.payload.data,
        totalCountInUsermanagement:action.payload.data?.data.total_count,
        editFormInitialValues: action.payload.data?.data?.viewuser.map((userinfo, index) => {
          return {
            user_id: userinfo.user_id,
            role_name: userinfo.role_name,
            role_id: userinfo.role_id,
            email: userinfo.email_id,
            firstName: userinfo.firstName,
            lastName: userinfo.lastName,
          }
        }),
      }
    }
    case SEARCH_USER: {
      return {
        ...state,
        userManagementList: action.payload.data,
      }
    }
    case USERMANAGEMENT_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
        userManagementList: {},
      }
    }

    case REMAINING_LICENSES_SUCCESS: {
      return {
        ...state,
        remainingLicensesLoading: false,
        remainingLicenses: action.payload.data,
      }
    }
    case REMAINING_LICENSES_FAILURE: {
      return {
        ...state,
        remainingLicensesLoading: false,
        remainingLicenses: {},
      }
    }

    case ADD_USER_SUCCESS: {
      return {
        ...state,
        addUserLoading: false,
        addUserRes: action.payload.data,
      }
    }
    case ADD_USER_FAILURE: {
      return {
        ...state,
        addUserLoading: false,
        addUserRes: {},
      }
    }

    case UPDATE_USER_SUCCESS: {
      return {
        ...state,
        updateUserLoading: false,
        updateUserRes: action.payload,
      }
    }
    case UPDATE_USER_FAILURE: {
      return {
        ...state,
        updateUserLoading: false,
        updateUserRes: {},
      }
    }

    case DELETE_USER_SUCCESS: {
      return {
        ...state,
        deleteUserLoading: false,
        deleteUserRes: action.payload.data,
      }
    }
    case DELETE_USER_FAILURE: {
      return {
        ...state,
        deleteUserLoading: false,
        deleteUserRes: {},
      }
    }

    case GET_ROLE_LIST_SUCCESS: {
      return {
        ...state,
        roleListLoading: false,
        roleList: action.payload.data?.data?.roles.map((dat, indx) => {
          return {
            label: dat.role_name,
            value: dat.role_id,
          }
        }),
        roleForAdmin: action.payload.data?.data?.roles.filter((roles)=> roles.role_name !== 'Admin' && roles.role_name !== 'Super Admin').map(
          (dat, indx) => {
            return {
              label: dat.role_name,
              value: dat.role_id,
            }
          }
        )
      }
    }
    case GET_ROLE_LIST_FAILURE: {
      return {
        ...state,
        roleListLoading: false,
        roleList: {},
      }
    }

    case GET_COMPANY_LIST_SUCCESS: {
      return {
        ...state,
        getCompanyLoading: false,
        getCompanyList: action.payload.data?.data.companyList.map((company, index) => {
          return {
            label: company.company_name,
            value: company.company_id,
          }
        }),
      }
    }
    case GET_COMPANY_LIST_FAILURE: {
      return {
        ...state,
        getCompanyLoading: false,
        getCompanyList: {},
      }
    }

    case GET_TOOLTIP_SUCCESS: {
      return {
        ...state,
        tooltiplistLoading: false,
        tooltiplist: action.payload.data,
      }
    }
    case GET_TOOLTIP_FAILURE: {
      return {
        ...state,
        tooltiplistLoading: false,
        tooltiplist: {},
      }
    }
    case ACTIVE_DEACTIVE_SUCCESS: {
      return {
        ...state,
        activeDeactiveLoading: false,
        activeDeactiveRes: action.payload.data,
      }
    }
    case ACTIVE_DEACTIVE_FAILURE: {
      return {
        ...state,
        activeDeactiveLoading: false,
        activeDeactiveRes: {},
      }
    }
    case RESET_TOAST_MESSAGE: {
      return {
        ...state,
        updateUserRes: undefined,
        addUserRes: undefined,
        deleteUserRes: undefined,
        activeDeactiveRes: undefined
      }
    }
    default: {
      return {
        ...state,
      }
    }
  }
}

export default userManagementReducer
